module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/accountmaster-menu/accountmaster-menu.component.css
// module id = ./src/app/accountmaster/accountmaster-menu/accountmaster-menu.component.css
// module chunks = main